"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectDefaultMarketByMatchId = exports.selectMatchesByFavoriteIds = exports.selectTournamentById = exports.selectFavoriteIdsByTournament = exports.makeSelectFavoriteMatchesByStatus = exports.selectFavoriteMatches = exports.selectIsFavoriteSportEvent = exports.selectFavoriteIds = exports.selectTournamentByIdFromProps = exports.selectFavorite = void 0;
var reselect_1 = require("reselect");
var core_1 = __importStar(require("@gin-betting/core"));
var constants_1 = require("@gin-betting/constants");
var immutable_1 = require("immutable");
var _a = core_1.default.entities.selectors, selectMatches = _a.selectMatches, makeEntitySelector = _a.makeEntitySelector, selectMarkets = _a.selectMarkets, selectMatchIdFromProps = _a.selectMatchIdFromProps, selectMatch = _a.selectMatch, selectTournamentIdFromProps = _a.selectTournamentIdFromProps, _b = core_1.default.utils, getFiltersFromLocation = _b.getFiltersFromLocation, getBettingOptions = _b.getBettingOptions;
var selectFavorite = function (state) { return state.get('favorite'); };
exports.selectFavorite = selectFavorite;
// TODO: should be removed, selectTournamentByIdFromProps don't used in any project
exports.selectTournamentByIdFromProps = selectTournamentIdFromProps;
exports.selectFavoriteIds = reselect_1.createSelector(exports.selectFavorite, function (favorite) {
    return favorite.get('favoriteIds');
});
exports.selectIsFavoriteSportEvent = reselect_1.createSelector(selectMatchIdFromProps, exports.selectFavoriteIds, function (sportEventId, favoriteIds) { return favoriteIds.has(sportEventId); });
exports.selectFavoriteMatches = reselect_1.createSelector(selectMatches, exports.selectFavoriteIds, function (matches, favoriteIds) {
    return favoriteIds.reduce(function (acc, id) {
        var match = matches.get(id);
        if (!match)
            return acc;
        return acc.concat([match]);
    }, []);
});
var makeSelectFavoriteMatchesByStatus = function (statuses, _a) {
    var _b = _a === void 0 ? { isAllSports: false } : _a, isAllSports = _b.isAllSports;
    return reselect_1.createSelector(exports.selectFavoriteIds, selectMatches, getBettingOptions, function (favoriteIds, matches, _a) {
        var selectedSportIds = _a.selectedSportIds;
        var favoriteMatches = immutable_1.List();
        favoriteIds.forEach(function (favoriteId) {
            var match = matches.get(favoriteId);
            if (match &&
                statuses.includes(match.status) &&
                (isAllSports || selectedSportIds.includes(match.sportId))) {
                favoriteMatches = favoriteMatches.push(match);
            }
        });
        return favoriteMatches;
    });
};
exports.makeSelectFavoriteMatchesByStatus = makeSelectFavoriteMatchesByStatus;
exports.selectFavoriteIdsByTournament = reselect_1.createSelector(selectMatches, exports.selectFavoriteIds, getFiltersFromLocation, getBettingOptions, function (matches, favoriteIds, _a, _b) {
    var tournamentIds = _a.tournamentIds;
    var selectedSportIds = _b.selectedSportIds;
    return favoriteIds.filter(function (sportEventId) {
        var match = matches.get(sportEventId);
        if (!match)
            return false;
        var status = match.status, tournament = match.tournament, sportId = match.sportId;
        if (tournamentIds)
            return tournamentIds.includes(tournament);
        var isPrematch = status === core_1.GQL.SportEventStatus.NOT_STARTED;
        return isPrematch && selectedSportIds.includes(sportId);
    });
});
// TODO: move to core
exports.selectTournamentById = makeEntitySelector('tournaments', selectTournamentIdFromProps);
exports.selectMatchesByFavoriteIds = reselect_1.createSelector(selectMatches, exports.selectFavoriteIds, function (matches, favoriteIds) {
    return favoriteIds.filter(function (favoriteId) { return !matches.has(favoriteId); });
});
exports.selectDefaultMarketByMatchId = reselect_1.createSelector(selectMatch, selectMarkets, function (match, markets) {
    var defaultMarket = match === null || match === void 0 ? void 0 : match.markets.filter(function (marketId) { return markets.has(marketId); }).map(function (marketId) { return markets.get(marketId); }).find(function (_a) {
        var specifiers = _a.specifiers;
        return !specifiers.some(function (_a) {
            var name = _a.name;
            return [constants_1.SpecifierName.total, constants_1.SpecifierName.hcp].includes(name);
        });
    });
    return defaultMarket;
});
//# sourceMappingURL=selectors.js.map